module.exports = __webpack_public_path__ + "img/crc-07.111ae29c.jpg";